import Vuex from 'vuex'
import Vue from 'vue'
import { getField, updateField } from 'vuex-map-fields'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ids: {
      get_id: '',
      customer_id: '',
      contract_id: '',
      customer_name: '',
      nkh_course_type_id: '',
      contract_driving_school: '',
      contract_type: '',
      driving_school: ''
    },
    actions: {
      preloader: false,
      message_dialog: false
    },
    user_datas: {
      contracts: [],
      studDetailsVaild: true,
    }
  },

  getters: {
    getField
  },

  mutations: {
    updateField
  },

  actions: {

  }
})
